// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-container {
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

.filter-buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.recharts-wrapper{
  margin-left:15px;
}

.filter-buttons button {
  padding: 8px 10px;
  font-size: 1em;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.filter-buttons button.active {
  background-color: #0056b3;
}

.filter-buttons button:hover {
  background-color: #0056b3;
}

@media (max-width: 600px) {
  .chart-container {
    padding: 10px; /* Reduce padding on mobile */
  }

  .filter-buttons {
    flex-direction: row;
    align-items: center;
  }

  .recharts-wrapper{
    min-width: 100%;
    margin-left:-25px;
  }
  

  .filter-buttons button {
    max-width: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PriceHistoryChart.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa,EAAE,6BAA6B;EAC9C;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;;EAGA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".chart-container {\n  margin: 0 auto;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.filter-buttons {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.recharts-wrapper{\n  margin-left:15px;\n}\n\n.filter-buttons button {\n  padding: 8px 10px;\n  font-size: 1em;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.filter-buttons button.active {\n  background-color: #0056b3;\n}\n\n.filter-buttons button:hover {\n  background-color: #0056b3;\n}\n\n@media (max-width: 600px) {\n  .chart-container {\n    padding: 10px; /* Reduce padding on mobile */\n  }\n\n  .filter-buttons {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .recharts-wrapper{\n    min-width: 100%;\n    margin-left:-25px;\n  }\n  \n\n  .filter-buttons button {\n    max-width: 200px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
